import NavLinksAdmin from "../../components/navlinksAdmin/NavLinksAdmin";

import { UsersTable } from "../../components/UsersTable/UsersTable";

export default function AdminUsers() {
  return (
    <div className="inside-page-container-blk">
      <div className="create-badge-main-container">
        <NavLinksAdmin />
        <div>
          <UsersTable />
        </div>
      </div>
    </div>
  );
}
